<template>
  <div>
    <div
      class="wrapper"
      v-if="
        bargainNew != null &&
        bargainNew.orders != null &&
        bargainNew.orders.length != 0
      "
    >
      <div class="mgt10 mgb10">
        <span>已添加产品：</span>
        <span class="font10 orange mgr10">
          {{ bargainNew.productNoQty }} 款 {{ bargainNew.productQty }} 件

          {{ $t("order.subtotal") }}:{{ currencySymbol
          }}{{ bargainNew.amount || 0 }}
        </span>
        <span v-if="$route.query.payBalance == 'true'" class="red">
          {{ $t("customer.balance")
          }}{{ $route.query.customerBalance | currency }}
        </span>
      </div>
      <vxe-table
        :data="bargainNew.orders"
        size="mini"
        class="recordsTable"
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            {{ row.serialNo }}
            <div class="font10">{{ row.innerSerialNo }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="140"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >

            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="price"
          :title="$t('order.price')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ currencySymbol }}
            {{ row.price }}
            <small v-if="row.discountRate != null && row.discountRate != 0"
              >({{ row.discountRate }}%)</small
            >
            <div
              v-if="row.extraCharge != null && row.extraCharge != 0"
              class="font10"
            >
              {{ $t("order.extraChargeSimple") }}:
              {{ currencySymbol }}
              {{ row.extraCharge }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <div>
              <raw-html-limit-number
                :content="row.remark"
                :number="12"
                type="richText"
              />
            </div>
            <div>
              <attribute :content="row.specJson" :number="12" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="
            !Permit.isFreeEdition() && Permit.extendModels().includes('wms')
          "
          :title="$t('order.wmsInfo')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <div
              v-for="i of row.inventories.filter((i) => i.quantity != 0)"
              :key="i.id"
              class="font10"
            >
              {{ i.shopName }}：{{ i.quantity }}/{{ i.customQuantity }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column field="action" :title="$t('text.action')" width="50">
          <template v-slot="{ row, rowIndex }">
            <el-button
              type="text"
              size="mini"
              @click="editOrder(row, rowIndex)"
              >{{ $t("text.edit") }}</el-button
            >
            <div>
              <el-button
                type="text"
                size="mini"
                @click="copyOrder(row, rowIndex)"
                >{{ $t("action.copy") }}</el-button
              >
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <br />
    </div>

    <!-- <el-dialog
      :title="$t('text.edit')"
      width="60%"
      v-if="editOrderDialogDF"
      :visible.sync="editOrderDialogDF"
      :close-on-click-modal="false"
    >
      <el-form
        v-if="order != null"
        ref="orderForm"
        :model="order"
        label-width="80px"
        size="small"
        class="box"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="$t('order.innerSerialNo')"
              :prop="'innerSerialNo'"
            >
              <el-input size="small" v-model.trim="order.innerSerialNo" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('order.dealSuggest')"
              :prop="'dealSuggest'"
            >
              <el-input
                size="small"
                v-model.trim="order.dealSuggest"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('text.handOverAt')">
              <el-date-picker
                v-model="order.handOverAt"
                type="date"
                style="width: 100%"
                :picker-options="pickerTodayAfterTime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="$t('product.productNo')"
              :prop="'productNo'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('product.productNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                v-model="order.productNo"
                :fetch-suggestions="querySearchProductNo"
                :trigger-on-focus="false"
                style="width: 100%"
                @select="handleSelectProductNo"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.productNo }}</div>
                  <span class="addr">{{ item.productNoAlias }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('order.customerProductNo')"
              :prop="'customerProductNo'"
            >
              <el-input
                size="small"
                v-model.trim="order.customerProductNo"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('product.category')" :prop="'categoryId'">
              <el-select
                size="small"
                v-model="order.categoryId"
                clearable
                @change="selsectCategory"
              >
                <el-option
                  v-for="category in categories"
                  :key="category.id"
                  :label="category.name"
                  :value="category.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="16">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('product.size')" :prop="'size'">
                  <el-autocomplete
                    size="small"
                    v-model.trim="order.size"
                    :fetch-suggestions="querySearchSize"
                    style="width: 100%"
                    @select="handleSelectSize"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('product.color')" :prop="'color'">
                  <el-autocomplete
                    size="small"
                    v-model.trim="order.color"
                    :fetch-suggestions="querySearchColor"
                    style="width: 100%"
                    @select="handleSelectColor"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  :label="$t('order.price')"
                  :prop="'price'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('order.price')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="order.price"
                    :placeholder="currencySymbol"
                    @blur="blurPrice"
                  >
                    <div slot="append" class="font10">
                      售 {{ currencySymbol }}{{ order.productPrice || 0 }}
                    </div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('order.discountRate')"
                  :prop="'discountRate'"
                >
                  <el-input
                    size="small"
                    v-model.trim="order.discountRate"
                    @blur="blurDiscountRate"
                  >
                    <div slot="append">%</div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('order.colorImage')" :prop="'colorImage'">
              <upload-single-picture v-model="order.colorImage" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              :label="$t('text.quantity')"
              :prop="'quantity'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.quantity')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-row>
                <el-col :span="14">
                  <el-input
                    size="small"
                    v-model.trim="order.quantity"
                  ></el-input>
                </el-col>
                <el-col :span="10">
                  <el-select size="small" v-model="order.unit" clearable>
                    <el-option
                      v-for="unit in units"
                      :key="unit"
                      :label="unit"
                      :value="unit"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('order.extraCharge')"
              :prop="'extraCharge'"
            >
              <el-input
                size="small"
                v-model.trim="order.extraCharge"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('order.subtotal')">
              {{ currencySymbol }}
              {{ order.price * order.quantity + Number(order.extraCharge) }}
            </el-form-item>
          </el-col>
        </el-row>
        <fieldset v-if="productNoAttributes.length != 0" class="mgb15">
          <legend>{{ $t("product.specJson") }}</legend>
          <el-row :gutter="20" class="mgb10">
            <el-col
              v-for="attribute in productNoAttributes"
              :key="attribute.name"
              :span="6"
              class="mgb10"
            >
              <el-input v-model.trim="attribute.value" size="small">
                <template slot="prepend">
                  <div>
                    <raw-html-limit-number
                      :content="attribute.name"
                      :number="6"
                    />
                  </div>
                </template>
              </el-input>
            </el-col>
          </el-row>
        </fieldset>
        <el-row :gutter="20">
          <el-col :span="16">
            <fieldset class="mgb15">
              <legend>
                {{ $t("product.images") }}
              </legend>
              <dropzone v-model="order.images" multiple />
            </fieldset>
          </el-col>
          <el-col :span="8">
            <fieldset class="mgb15">
              <legend>{{ $t("product.attachment") }}</legend>
              <div class="mgb10">
                <small class="orange">{{
                  $t("product.attachmentExplain")
                }}</small>
              </div>
              <attachment v-model="order.attachment" />
            </fieldset>
          </el-col>
        </el-row>
        <fieldset class="mgb15">
          <legend>{{ $t("text.remark") }}</legend>
          <tinymce-editor
            ref="editor"
            v-model="order.remark"
            :height="300"
            :menubar="true"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="submitDoing"
          size="small"
          @click="submit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editOrderDialogDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog> -->

    <drawer
      :title="$t('text.edit', [$t('menu.orders')])"
      :visible.sync="editOrderDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit-order :id="currentRowOrderId" @updateInfo="orderUpdated" />
    </drawer>

    <el-dialog
      :title="$t('action.copy')"
      :close-on-click-modal="false"
      v-if="copyOrderDF"
      :visible.sync="copyOrderDF"
      width="30%"
    >
      <copy-order
        :id="currentRowOrderId"
        @updated="copyUpdated"
        @close="copyOrderDF = false"
        source="newedOrders"
        :serialNo="copySerialNo"
      />
    </el-dialog>
  </div>
</template>

<script>
// import axios from "axios";
// import Vue from "vue";
// import ls from "store2";

import { page } from "@/utils/mixins.js";
// import Util from "@/utils";
// import UploadSinglePicture from "@/components/UploadSinglePicture";
// import Dropzone from "@/components/Dropzone";
// import Attachment from "@/components/Attachment";
// import TinymceEditor from "@/components/TinymceEditor";

import CopyOrder from "./copyOrder.vue";
import EditOrder from "./editOrder.vue";
// import Product from "@/api/product.js";
// import Category from "@/api/category.js";
// import Size from "@/api/size.js";
// import Enumeration from "@/api/enumeration.js";
// import Color from "@/api/color.js";

// import Order from "@/api/order.js";
import Bargain from "@/api/bargain.js";

export default {
  props: {
    bargain: Object,
    currencySymbol: String,
    updateDataDF: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [page],
  components: {
    // UploadSinglePicture,
    // Dropzone,
    // Attachment,
    // TinymceEditor,
    CopyOrder,
    EditOrder,
  },
  data() {
    return {
      // pickerTodayAfterTime: {
      //   disabledDate(time) {
      //     return time.getTime() < Date.now() - 8.64e7;
      //   },
      // },
      // order: null,
      // rowIndex: null,
      // editOrderDialogDF: false,

      // categories: [],
      // sizes: [],
      // units: [],
      // colors: [],
      // attributes: [],

      // cnyRate: null,
      // productNoColors: [],
      // productNoSizes: [],
      // productNoAttributes: [],
      // products: [],
      // categorySizes: [],
      // //
      // productSizePrices: [],
      // productWholesalePrice: null,
      // productSalesPrice: null,
      // quotationPrice: null,
      // quotationSizePrices: [],
      // CNYPrice: null,
      // _oldSizeExplain: null,
      // submitDoing: false,
      bargainNew: null,
      currentRowOrderId: null,
      // 复制订单
      copyBargainDF: false,
      copyOrderDF: false,
      copySerialNo: null,
      //
      editOrderDF: false,
    };
  },
  created() {
    const self = this;
    self.bargainNew = self.bargain;
  },
  methods: {
    copyUpdated() {
      this.getBargain();
      this.copyOrderDF = false;
    },
    copyOrder(row) {
      this.copySerialNo = row.serialNo;
      this.currentRowOrderId = row.id;
      this.copyOrderDF = true;
    },

    // 编辑
    editOrder(row, rowIndex) {
      this.currentRowOrderId = row.id;
      this.currentRowIdx = rowIndex;
      this.editOrderDF = true;
    },
    orderUpdated(order) {
      this.getBargain();
      this.editOrderDF = false;
    },

    getBargain() {
      const self = this;
      Bargain.findByUuid({ uuid: self.bargain.uuid }).then(function (res) {
        if (res.status === 200) {
          self.bargainNew = res.data.entity;
        } else {
          self.sysError();
        }
      });
    },

    // editOrder(row, rowIndex) {
    //   const self = this;
    //   this.order = row;
    //   this.rowIndex = rowIndex;
    //   // 币种
    //   const currentCurrencies = ls.session("CURRENCIES");
    //   const currencyObj = currentCurrencies.find(
    //     (c) => c.code === row.currency
    //   );
    //   if (currencyObj != null) {
    //     self.cnyRate = currencyObj.cnyRate;
    //   } else {
    //     self.cnyRate = 1;
    //   }
    //   axios
    //     .all([
    //       Category.findByTenantId(),
    //       Size.findByTenantId(),
    //       Enumeration.findByType("unit"),
    //       Color.findByTenantId(),
    //       Enumeration.findByType("attribute"),
    //     ])
    //     .then(
    //       axios.spread(function (categories, sizes, units, colors, attributes) {
    //         if (categories.status === 200) {
    //           self.categories = categories.data;
    //         } else {
    //           self.sysError();
    //         }
    //         if (sizes.status === 200) {
    //           self.sizes = sizes.data;
    //         } else {
    //           self.sysError();
    //         }
    //         if (units.data.code === 200) {
    //           self.units = JSON.parse(units.data.entity.itemsJson);
    //         } else {
    //           self.sysError();
    //         }
    //         if (colors.status === 200) {
    //           self.colors = colors.data;
    //         } else {
    //           self.sysError();
    //         }
    //         if (attributes.data.code === 200) {
    //           self.attributes = JSON.parse(attributes.data.entity.itemsJson);
    //         } else {
    //           self.sysError();
    //         }
    //         self.initData();
    //       })
    //     );
    //   self.editOrderDialogDF = true;
    // },
    // initData() {
    //   const self = this;
    //   let sizeObj = self.sizes.find((s) => s.name === this.order.size);
    //   if (sizeObj != null) {
    //     self._oldSizeExplain = sizeObj.explain;
    //   }
    //   Product.findByProductNo({
    //     productNo: self.order.productNo,
    //   }).then(function (res) {
    //     if (res.data.code === 200) {
    //       const product = res.data.entity;
    //       self.productNoColors =
    //         product.colors.length !== 0
    //           ? product.colors
    //           : self.colors.map((c) => c.name);
    //       self.productNoSizes =
    //         product.sizes.length !== 0
    //           ? product.sizes
    //           : self.sizes.map((s) => s.name);
    //       self.productNoAttributes =
    //         JSON.parse(product.customAttributeJson).length !== 0
    //           ? JSON.parse(product.customAttributeJson).map((att) => {
    //               return { name: att, value: null };
    //             })
    //           : self.attributes.map((att) => {
    //               return { name: att, value: null };
    //             });
    //       self.productSizePrices = product.productSizePrices;
    //       self.productCostPrice = product.costPrice;
    //       self.productWholesalePrice = product.wholesalePrice;
    //       self.productSalesPrice = product.salesPrice;
    //     } else {
    //       self.productNoColors = self.colors.map((c) => c.name);
    //       self.productNoSizes = self.sizes.map((s) => s.name);
    //       self.productNoAttributes = self.attributes.map((att) => {
    //         return { name: att, value: null };
    //       });
    //     }

    //     let orderSpecJsonArrs = [];
    //     if (self.order.specJson != null && self.order.specJson != "") {
    //       orderSpecJsonArrs = JSON.parse(self.order.specJson);
    //     }
    //     if (orderSpecJsonArrs.length !== 0) {
    //       for (const orderSpecJsonArr of orderSpecJsonArrs) {
    //         if (
    //           self.productNoAttributes.find(
    //             (productAtt) => productAtt.name === orderSpecJsonArr.name
    //           ) == null
    //         ) {
    //           self.productNoAttributes.push({
    //             name: orderSpecJsonArr.name,
    //             value: orderSpecJsonArr.value,
    //           });
    //         } else {
    //           const index = self.getIndexOf(self.productNoAttributes, {
    //             name: orderSpecJsonArr.name,
    //             value: null,
    //           });
    //           self.productNoAttributes[index].value = orderSpecJsonArr.value;
    //         }
    //       }
    //     }
    //   });
    // },
    // getIndexOf(arrs, obj) {
    //   for (const i in arrs) {
    //     if (arrs[i].name === obj.name) {
    //       return i;
    //     }
    //   }
    // },
    // // 货号
    // querySearchProductNo(queryString, cb) {
    //   const self = this;
    //   //
    //   self.productNoColors = self.colors.map((c) => c.name);
    //   self.productNoSizes = self.sizes.map((s) => s.name);
    //   self.productNoAttributes = self.attributes.map((att) => {
    //     return { value: null, name: att };
    //   });
    //   //
    //   self.productSizePrices = [];
    //   self.productWholesalePrice = null;
    //   self.productSalesPrice = null;
    //   self.quotationPrice = null;
    //   self.quotationSizePrices = [];

    //   //
    //   if (queryString == null || queryString.length < 1) {
    //     return;
    //   }
    //   Product.vagueFindByProductNo({ productNo: queryString }).then(function (
    //     res
    //   ) {
    //     self.products = res.data;
    //     if (self.products.length !== 0) {
    //       for (const p of self.products) {
    //         Vue.set(p, "value", p.productNo);
    //       }
    //     }
    //     cb(self.products);
    //   });
    // },
    // handleSelectProductNo(item) {
    //   const self = this;
    //   self.order.productNo = item.productNo;
    //   self.order.categoryId = item.categoryId;
    //   self.order.categoryName = item.categoryName;
    //   self.selsectCategory();
    //   self.order.images = item.images;
    //   self.order.craftwork = item.craftwork;
    //   self.order.remark = (self.order.remark || "") + (item.introduction || "");
    //   self.order._productIntroduction = item.introduction;
    //   self.productNoColors = item.colors;
    //   self.productNoSizes = item.sizes;
    //   if (
    //     item.customAttributeJson != null &&
    //     item.customAttributeJson !== "[]"
    //   ) {
    //     self.productNoAttributes = JSON.parse(item.customAttributeJson).map(
    //       (att) => {
    //         return { value: null, name: att };
    //       }
    //     );
    //   }
    //   self.productSizePrices = item.productSizePrices;
    //   self.productCostPrice = item.costPrice;
    //   self.productWholesalePrice = item.wholesalePrice;
    //   self.productSalesPrice = item.salesPrice;
    // },
    // selsectCategory() {
    //   const self = this;
    //   if (self.order.categoryId === "") {
    //     self.order.categoryId = null;
    //   }
    //   self.categorySizes = [];
    //   if (self.order.categoryId != null && self.order.categoryId !== "") {
    //     const selsectCategoryObj = self.categories.find(
    //       (c) => c.id === self.order.categoryId
    //     );
    //     if (
    //       selsectCategoryObj &&
    //       selsectCategoryObj.sizes != null &&
    //       selsectCategoryObj.sizes.length !== 0
    //     ) {
    //       self.categorySizes = selsectCategoryObj.sizes;
    //     }
    //   }
    // },
    // // 颜色
    // querySearchColor(queryString, cb) {
    //   const colors =
    //     this.productNoColors.length !== 0
    //       ? this.productNoColors.map((pc) => {
    //           return { value: pc };
    //         })
    //       : this.colors.map((c) => {
    //           return { value: c.name };
    //         });
    //   if (queryString == null) {
    //     cb(colors);
    //   } else {
    //     cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
    //   }
    // },
    // handleSelectColor() {
    //   this.order.color = Util.jyTrim(this.order.color);
    //   //
    //   this.order.colorImage = null;
    //   const colorObj = this.colors.find((c) => c.name === this.order.color);
    //   if (colorObj != null && colorObj.image != null) {
    //     this.order.colorImage = colorObj.image;
    //   }
    // },
    // // 规格
    // querySearchSize(queryString, cb) {
    //   const self = this;
    //   let sizes = [];
    //   if (self.productNoSizes.length !== 0) {
    //     sizes = this.productNoSizes.map((pc) => {
    //       return { value: pc };
    //     });
    //   } else {
    //     if (self.categorySizes.length !== 0) {
    //       sizes = this.categorySizes.map((c) => {
    //         return { value: c.name, explain: c.explain };
    //       });
    //     } else {
    //       sizes = this.sizes.map((c) => {
    //         return { value: c.name, explain: c.explain };
    //       });
    //     }
    //   }
    //   if (queryString == null) {
    //     cb(sizes);
    //   } else {
    //     cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
    //   }
    // },
    // handleSelectSize() {
    //   const self = this;
    //   self.order.size = Util.jyTrim(self.order.size);
    //   self.computeRemark();
    // },
    // computeRemark() {
    //   const self = this;
    //   const sizeObj = self.sizes.find((s) => s.name === this.order.size);
    //   // 替换已经有的尺码说明
    //   if (self.order.remark != null && self._oldSizeExplain != null) {
    //     self.order.remark = self.order.remark.replace(
    //       ";【" + self._oldSizeExplain + "】",
    //       ""
    //     );
    //     self.order.remark = self.order.remark.replace(
    //       "<br/>【" + self._oldSizeExplain + "】",
    //       ""
    //     );
    //     self.order.remark = self.order.remark.replace(
    //       "【" + self._oldSizeExplain + "】",
    //       ""
    //     );
    //     self.order.remark = self.order.remark.replace(self._oldSizeExplain, "");
    //   }
    //   // 加入新的尺码说明
    //   if (sizeObj != null && sizeObj.explain != null && sizeObj.explain != "") {
    //     if (this.order.remark !== null && self.order.remark != "") {
    //       self.order.remark =
    //         self.order.remark + "<br/>【" + sizeObj.explain + "】";
    //     } else {
    //       this.order.remark = "【" + sizeObj.explain + "】";
    //     }
    //     self._oldSizeExplain = sizeObj.explain;
    //   }
    // },
    // blurPrice() {
    //   if (
    //     this.order.productPrice != null &&
    //     this.order.productPrice !== 0 &&
    //     this.order.price != null
    //   ) {
    //     this.order.discountRate = Util.toFixed(
    //       (this.order.price / this.order.productPrice) * 100,
    //       3
    //     );
    //   }
    // },
    // blurDiscountRate() {
    //   if (
    //     this.order.discountRate !== null &&
    //     !Util.regexQuantity(this.order.discountRate)
    //   ) {
    //     this.$message({
    //       message: this.$t("rules.regex", [this.$t("order.discountRate")]),
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   if (this.order.productPrice != null) {
    //     this.order.price =
    //       this.order.productPrice * (this.order.discountRate / 100);
    //   }
    // },
    // submit() {
    //   const self = this;
    //   if (self.categories.find((s) => s.id === self.order.categoryId) != null) {
    //     self.order.categoryName = self.categories.find(
    //       (s) => s.id === self.order.categoryId
    //     ).name;
    //   }
    //   const attributesArr =
    //     self.productNoAttributes.length !== 0
    //       ? self.productNoAttributes.filter((sp) => sp.value != null)
    //       : [];
    //   self.order.specJson = JSON.stringify(attributesArr);
    //   self.order.color = Util.jyTrim(self.order.color);
    //   self.order.size = Util.jyTrim(self.order.size);
    //   if (self.order.productPrice == null || self.order.productPrice === "0") {
    //     self.order.productPrice = self.order.price;
    //   }
    //   if (self.order.handOverAt != null) {
    //     self.order.handOverAt = Util.formatDate(self.order.handOverAt);
    //   }

    //   self.saveDoing = true;
    //   Order.update(self.order.id, self.order).then(function (res) {
    //     self.saveDoing = false;
    //     self.editOrderDialogDF = false;
    //     if (res.status === 200) {
    //       self.$message({
    //         message: self.$t("prompt.editSuccess"),
    //         type: "success",
    //       });
    //       if (self.updateDataDF) {
    //         self.$emit("updateData");
    //       }
    //       Bargain.findByUuid({ uuid: self.bargain.uuid }).then(function (res) {
    //         if (res.status === 200) {
    //           let newBargain = res.data.entity;
    //           self.bargain.productNoQty = newBargain.productNoQty;
    //           self.bargain.productQty = newBargain.productQty;
    //           self.bargain.amount = newBargain.amount;
    //         } else {
    //           self.sysError();
    //         }
    //       });
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },
  },
};
</script>
